import { render } from "./basic-modal.vue?vue&type=template&id=37f9671e&ts=true"
import script from "./basic-modal.component.ts?vue&type=script&lang=ts"
export * from "./basic-modal.component.ts?vue&type=script&lang=ts"

import exportComponent from "/Volumes/ExDisk/Cong viec/LuvTransitltms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__